import Vue from 'vue';
import { appInfo } from '@eastmoney/mku';
import Cookies from 'js-cookie';
import { v4 as uuiidV4 } from 'uuid';
import store from '@/store';
import { CHANGE_PAGE_ENV_INFO } from '@/libs/constant';
import * as Sentry from 'emnj-sentry';

/**
 * 统计来源： 东财app 天天基金app 微信 手机浏览器 web端
 */
export const isAndroid = () => {
    return /(Android)/i.test(navigator.userAgent);
};

export const isIOS = () => {
    return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
};

export const isPC = () => {
    const userAgentInfo = navigator.userAgent;
    const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
};

const getDeviceId = async () => {
    try {
        const deviceIdKey = 'qn_dvc_id';
        let uuidDeviceId = Cookies.get(deviceIdKey) || localStorage.getItem(deviceIdKey);
        if (!uuidDeviceId) {
            uuidDeviceId = uuiidV4();
            Cookies.set(deviceIdKey, uuidDeviceId);
            localStorage.setItem(deviceIdKey, uuidDeviceId);
        }
        console.info(
            'cookie and localstorage deviceId: ',
            Cookies.get(deviceIdKey),
            localStorage.getItem(deviceIdKey)
        );
        store.commit(CHANGE_PAGE_ENV_INFO, {
            ...store.state.deviceInfo,
            deviceId: uuidDeviceId
        });
    } catch (error) {
        console.error('get deviceId error: ', error);
    }
};

export const getInitPageInfo = async () => {
    try {
        appInfo.inApp(
            () => {
                store.commit(CHANGE_PAGE_ENV_INFO, {
                    ...store.state.deviceInfo,
                    terminalType: 'dfcfapp'
                });
            },
            () => {
                appInfo.inTTJJ(
                    () => {
                        store.commit(CHANGE_PAGE_ENV_INFO, {
                            ...store.state.deviceInfo,
                            terminalType: 'ttjjapp'
                        });
                    },
                    () => {
                        if (appInfo.isWeChat) {
                            store.commit(CHANGE_PAGE_ENV_INFO, {
                                ...store.state.deviceInfo,
                                terminalType: 'wechat'
                            });
                        } else if (isPC()) {
                            store.commit(CHANGE_PAGE_ENV_INFO, {
                                ...store.state.deviceInfo,
                                terminalType: 'web'
                            });
                        } else {
                            store.commit(CHANGE_PAGE_ENV_INFO, {
                                ...store.state.deviceInfo,
                                terminalType: 'wap'
                            });
                        }
                    }
                );
            }
        );
        await getDeviceId();
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const device = {
    isIOS: isIOS(),
    isAndroid: isAndroid()
};

export const getDeviceInfo = () => {
    console.log('deviceId: ======>>>> ', store.state.deviceInfo.deviceId);
    console.log(window.location.href);
    return {
        deviceId: store.state.deviceInfo.deviceId || '',
        deviceType: device.isIOS ? 'iOS' : device.isAndroid ? 'Android' : 'PC',
        terminalType: store.state.deviceInfo.terminalType || ''
    };
};

export const getDrawInfo = () => {
    const drawToken = store.state.rewardConfig && store.state.rewardConfig.rewardToken;
    return {
        drawToken: drawToken || ''
    };
};

/**
 * 大数据埋点
 * @param {*} eventCode
 * @param {*} extroInfo
 * @param {*} gotoUrl
 */
export function track(eventCode = '', extroInfo = {}, gotoUrl = '') {
    try {
        const extroInfoStr = JSON.stringify({
            infoCode: store.state.questionnaireCode,
            ...extroInfo
        });
        window.sendTrackLog('div', 'click', eventCode, extroInfoStr, gotoUrl);
    } catch (error) {
        console.log(error);
    }
}

/**
 * 大数据 - 应用启动
 * @param {*} info
 */
export function trackLaunch(info = '') {
    try {
        const infoCode = info || store.state.questionnaireCode;
        window.emtjLaunch('', infoCode);
    } catch (error) {
        console.log(error);
    }
}
/**
 * 上传地址
 * @param {*} imageCode
 */
export function imageUrl(imageCode) {
    return `${window.location.origin}/questionnaire/api/questionnaire/resource/${
        store.state.questionnaireCode
    }?fileCode=${imageCode}&_t=${Date.now()}`;
    // return `https://quiz-activity.eastmoney.com/questionnaire/api/questionnaire/resource/${
    //     store.state.questionnaireCode
    // }?fileCode=${imageCode}&_t=${Date.now()}`;
}
/**
 * 初始化sentry
 * @param {*} router
 */
export function initSentry(router) {
    try {
        Sentry.startSentry(
            {
                Vue,
                dsn: 'https://3997f10bb8294474ae6270b3346bbfee@fenewmonitor.eastmoney.com/15',
                environment: process.env.BUILD_ENV
            },
            router
        );
        setTimeout(() => {
            Sentry.setTags({ code: store.state.questionnaireCode, plateform: 'h5' });
            Sentry.setUser({
                id: Cookies.get('ctoken') || '',
                username: store.state.questionnaireCode
            });
        }, 3000);
    } catch (error) {
        console.log(error);
    }
}
/**
 * 是否是eastmoney环境
 * @returns 是否eastmoney环境
 */
export function isEastmoneyDomain() {
    return window.location.hostname.includes('eastmoney.com');
}
